export default __webpack_public_path__ + "static/media/e-cpsr-logo.b16d7a26.svg";